/**
 * 物业报修
 */
export default [
  /**商户端 */
  {
    path: '/estate',
    component: () => import('@/views/estate/Index.vue'),
    meta: { requiresAuth: true, title: '物业报修', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import('@/views/estate/List.vue'),
          meta: { title: '物业报修-列表', role: true },
        },
        {
          path: 'form',
          component: () => import('@/views/estate/Form.vue'),
          meta: { title: '物业报修-新建保修', role: true },
        },
        {
          path: 'info',
          component: () => import('@/views/estate/info.vue'),
          meta: { title: '物业报修-详情', role: true },
        },
      ],
  },
  /**商管端 */
  {
    path: '/estateManage',
    component: () => import('@/views/estateManage/Index.vue'),
    meta: { requiresAuth: true, title: '物业报修', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import('@/views/estateManage/List.vue'),
          meta: { title: '物业报修-列表', role: true },
        },
        {
          path: 'form',
          component: () => import('@/views/estateManage/Form.vue'),
          meta: { title: '物业报修-新建保修', role: true },
        },
        {
          path: 'info',
          component: () => import('@/views/estateManage/info.vue'),
          meta: { title: '物业报修-详情', role: true },
        },
        {
          path: 'assign',
          component: () => import('@/views/estateManage/assign.vue'),
          meta: { title: '物业报修-确认分配', role: true },
        },
      ],
  },
  /**维修工端 */
  {
    path: '/estateWorker',
    component: () => import('@/views/estateWorker/Index.vue'),
    meta: { requiresAuth: true, title: '物业报修', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import('@/views/estateWorker/List.vue'),
          meta: { title: '物业报修-列表', role: true },
        },
        {
          path: 'info',
          component: () => import('@/views/estateWorker/info.vue'),
          meta: { title: '物业报修-详情', role: true },
        },
        {
          path: 'assign',
          component: () => import('@/views/estateWorker/assign.vue'),
          meta: { title: '物业报修-确认分配', role: true },
        },
        {
          path: 'repair',
          component: () => import('@/views/estateWorker/repair.vue'),
          meta: { title: '物业报修-报修页', role: true },
        },
      ],
  },
];
